import { handleAjaxError, handleAjaxSuccess } from '../helpers.js';

const SAVE_ERROR_MESSAGE = 'Your payment sharing choice was not saved, please try again.';

function readConfig() {
    const el = document.getElementById('payment-sharing-prompt-modal-config');
    if (!el) {
        return {};
    }
    try {
        return JSON.parse(el.textContent || '{}');
    } catch (err) {
        return {};
    }
}

export function initPaymentSharingPromptModal() {
    const config = readConfig();
    let answered = false;

    function dismiss() {
        if (answered) {
            return;
        }
        answered = true;
        $.ajax({
            url: config.saveUrl,
            type: 'POST',
            data: {
                _token: config.csrfToken,
            },
            success: (response) => {
                const payload = response || { success: false };
                handleAjaxSuccess(payload);
                if (!payload.success) {
                    answered = false;
                }
            },
            error: (xhr) => {
                answered = false;
                handleAjaxError({ xhr, message: SAVE_ERROR_MESSAGE });
            },
        });
    }

    function save() {
        const shareAcrossCongregations = $('#paymentSharingPromptToggle').prop('checked');
        $.ajax({
            url: config.saveUrl,
            type: 'POST',
            data: {
                share_payment_methods_across_congregations: shareAcrossCongregations ? 1 : 0,
                _token: config.csrfToken,
            },
            success: (response) => {
                handleAjaxSuccess(response || { success: false }, {
                    redirect: () => {
                        answered = true;
                        $('#paymentSharingPromptModal').modal('hide');
                    },
                });
            },
            error: (xhr) => handleAjaxError({ xhr, message: SAVE_ERROR_MESSAGE }),
        });
    }

    $(document)
        .off('click.paymentSharingPromptSave', '#paymentSharingPromptSave')
        .on('click.paymentSharingPromptSave', '#paymentSharingPromptSave', save);

    $('#paymentSharingPromptModal')
        .off('hidden.bs.modal.paymentSharingPrompt')
        .on('hidden.bs.modal.paymentSharingPrompt', dismiss);
}

export function showPaymentSharingPromptModal() {
    $('#paymentSharingPromptModal').modal('show');
}

export function showPendingPaymentSharingPrompt() {
    if (readConfig().pending) {
        initPaymentSharingPromptModal();
        showPaymentSharingPromptModal();
    }
}
